import { createSlice } from "@reduxjs/toolkit"

const initialStateResultadoGrillaFacturaJuicio= {
  dataGrillaFactura: []
}; 

export const resultadoGrillaFacturaJuicioSlice = createSlice({ 
  name: "resultadoGrillaFacturaJuicio", 
  initialState: initialStateResultadoGrillaFacturaJuicio, 
  reducers:{
    setResultadoGrilla: (state, action)=>{
      state.dataGrillaFactura=action.payload
    },
    resetResultadoGrilla: (state) => {
      state.dataGrillaFactura=initialStateResultadoGrillaFacturaJuicio.dataGrillaFactura
    }
  }
});

export const {resetResultadoGrilla, setResultadoGrilla} = resultadoGrillaFacturaJuicioSlice.actions
export default resultadoGrillaFacturaJuicioSlice.reducer
